import SBPhoneInput from '@modules/sb-antd-phone-input/SBPhoneInput'
import { emailRule, isE164Phone, requiredRule } from '@utils/rules'
import { Divider, Form, Input } from 'antd'

interface Props {
  index: number
}

function ContactFields({ index }: Props) {
  return (
    <>
      <Form.Item
        label={'First name'}
        name={['persons', index, 'firstName']}
        rules={[requiredRule()]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={'Last Name'}
        name={['persons', index, 'lastName']}
        rules={[requiredRule()]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={'Email'}
        name={['persons', index, 'email']}
        rules={[requiredRule(), emailRule()]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={'Phone'}
        name={['persons', index, 'phone']}
        rules={[isE164Phone()]}
      >
        <SBPhoneInput disableParentheses enableSearch size="large" />
      </Form.Item>
      <Divider />
    </>
  )
}

export default ContactFields
